<div id="mainDiv"
    class="d-flex flex-column justify-content-center align-items-center min-vh-100 p-3 p-md-4 style-gradient">

    <div class="card login-card shadow-lg border-0 w-100">
        <div class="card-body p-4 p-sm-5 text-center">

            <div class="mb-4">
                <img class="logo-img img-fluid" src="assets/Aether_Logo.png" alt="Aether Logo">
            </div>

            <!-- <div class="mb-4 d-flex justify-content-center">
                <div class="profile-icon-wrapper">
                    <img src="assets/user-profile.svg" alt="User Profile" class="profile-icon loginicon" />
                </div>
            </div> -->

            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

                <div class="mb-4 text-start">
                    <label
                        class="form-label fw-bold text-secondary aeLabel suffix_star text-uppercase tracking-wider">Email
                        / Mobile No</label>
                    <input class="form-control form-control-lg text-start input-theme py-3" type="text"
                        placeholder="Email / Mobile No" formControlName="userName" id="userName" required
                        autocomplete="username email" (keyup)="onKeypressEvent($event)">
                </div>

                <div class="mb-4 text-start">
                    <label
                        class="form-label fw-bold text-secondary aeLabel suffix_star text-uppercase tracking-wider">Password</label>

                    <div class="input-group">
                        <input [type]="show ? 'text' : 'password'" placeholder="Password" formControlName="password"
                            id="password" class="form-control form-control-lg text-start input-theme py-3" required
                            maxlength="100" autocomplete="current-password">

                        <button class="btn btn-append-toggle bg-white px-3" type="button" (click)="showPassword()">
                            <i style="color:black; position: initial;" class="{{passwordState}}"></i>
                        </button>
                    </div>

                    <div class="mt-2 text-end">
                        <span class="aeLabel resetpass fw-bold text-primary small-link" (click)="openResetPassword()">
                            Reset Password
                        </span>
                    </div>
                </div>

                <div class="mt-4 pt-2">
                    <button type="submit" value="submit" class="btn btn-lg w-100 fw-bold btn-submit-theme aeLabel py-3">
                        SIGN IN
                        <i class="fa-solid fa-arrow-right-to-bracket ms-2"></i>
                    </button>
                </div>

            </form>

        </div>
    </div>

</div>

<ng-template #resetPassAlertContent let-resetPassModal>
    <div class="modern-popup-wrapper">
        <!-- <div mat-dialog-title class="popup-header-theme text-white p-3 m-0">
            <h5 class="m-0 fw-bold">Reset Password</h5>
        </div> -->

        <mat-dialog-content class="p-4 m-0">
            <p class="text-muted mb-4 fs-6">Please enter your registered Email-Id down below.</p>

            <form [formGroup]="resetPassword">
                <div class="row align-items-center g-3">
                    <div class="col-md-3 text-md-start">
                        <label class="aeLabel fw-bold text-secondary text-uppercase small m-0">Email-Id:</label>
                    </div>
                    <div class="col-md-9">
                        <input class="aeLabel form-control form-control-lg" id="emailId" name="emailId"
                            formControlName="emailId" placeholder="Email-Id" />
                    </div>
                </div>
            </form>
        </mat-dialog-content>

        <mat-dialog-actions class="d-flex justify-content-end gap-2 p-3 bg-light border-top m-0">
            <button type="button" class="btn btn-light border px-4 fw-bold taskActionButton" aria-label="Close"
                (click)="resetPassModal.dismiss('Cross click')">No</button>

            <button type="button" class="btn btn-primary btn-search shadow-sm px-4"
                (click)="onResetPasswordSubmit(); resetPassModal.dismiss('Cross click')">Yes</button>
        </mat-dialog-actions>
    </div>
</ng-template>